export default [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/core/LoginView.vue')
  },
  {
    path: '/apps',
    name: 'Apps',
    component: () => import(/* webpackChunkName: "core" */ '@/views/core/AppsView.vue')
  },
  {
    path: '/patients',
    name: 'Patients',
    component: () => import(/* webpackChunkName: "core" */ '@/views/core/PatientListView.vue')
  },
  {
    path: '/businesses',
    name: 'Businesses',
    component: () => import(/* webpackChunkName: "core" */ '@/views/core/BusinessListView.vue')
  },
  {
    path: '/settings',
    redirect: '/settings/profile'
  },
  {
    path: '/settings/profile',
    name: 'Account Profile Settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/AccountProfileSettingsView.vue')
  },
  {
    path: '/settings/languages',
    name: 'Languages Settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/LanguagesSettingsView.vue')
  },
  {
    path: '/settings/contact-methods',
    name: 'Contact Methods',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/ContactMethodsSettingsView.vue')
  },
  {
    path: '/settings/services',
    name: 'Enabled Services',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/AccountServiceSettingsView.vue')
  },
  {
    path: '/settings/services/forms',
    name: 'Forms Service Settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/services/FormsServiceSettingsView.vue')
  },
  {
    path: '/settings/services/messaging',
    name: 'Messaging Service Settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/services/MessagingServiceSettingsView.vue')
  },
  {
    path: '/settings/services/faxing',
    name: 'Faxing Service Settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/services/FaxingServiceSettingsView.vue')
  },
  {
    path: '/settings/services/reminders',
    name: 'Reminders Service Settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/services/RemindersServiceSettingsView.vue')
  },
  {
    path: '/settings/services/telehealth',
    name: 'Telehealth Service Settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/services/TelehealthServiceSettingsView.vue')
  },
  {
    path: '/settings/integration',
    name: 'Integration Settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/IntegrationSettingsView.vue')
  },
  {
    path: '/settings/integration/advancedmd',
    name: 'AdvancedMD Integration Settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/integration/AdvancedMdIntegrationSettingsView.vue')
  },
  {
    path: '/settings/integration/practice-fusion',
    name: 'Practice Fusion Integration Settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/integration/PracticeFusionIntegrationSettingsView.vue')
  },
  {
    path: '/settings/integration/athenahealth',
    name: 'athenahealth Integration Settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/integration/AthenahealthIntegrationSettingsView.vue')
  },
  {
    path: '/settings/integration/eclinicalworks',
    name: 'eClinicalWorks Integration Settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/integration/EclinicalworksIntegrationSettingsView.vue')
  },
  {
    path: '/settings/billing',
    name: 'Billing Settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/BillingSettingsView.vue')
  },
  {
    path: '/settings/users',
    name: 'Account Users',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/AccountUsersView.vue')
  },
  {
    path: '/settings/myself',
    name: 'User Personal Settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/UserPersonalSettingsView.vue')
  },
  {
    path: '/invite/:url',
    name: 'Accept Invite',
    component: () => import(/* webpackChunkName: "core" */ '@/views/core/AcceptInviteView.vue')
  }
]